import { Pipe, PipeTransform } from '@angular/core';
import { ActivityPluseAggrigatorModel } from '@shared/model/activity-plus-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';

@Pipe({
  name: 'feedOtherActivities',
  standalone: true
})
export class FeedOtherActivitiesPipe implements PipeTransform {

  transform(feed: ActivityPluseAggrigatorModel, isInside = false): boolean {
    if (!isInside && feed?.mainFeed?.verb != ActivityVerbEnum.Liked && feed?.mainFeed?.verb != ActivityVerbEnum.Quoted && feed?.mainFeed?.verb != ActivityVerbEnum.Commented && feed?.otherFeeds?.length > 1)
      return true;
    return false;
  }

}
